export default {
  watch: {
    '$route.query.id'(n) {
      Object.assign(this.$data, this.$options.data());
      this.getData();
    }
  }
}
